
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type SearchBoxRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function SearchBoxRT(): TemplateResult<SearchBoxRTRootProps> {
    return _createElement('form', {
        'className': 'form',
        'onSubmit': this.preventFormSubmission
    }, _createElement('div', { 'className': 'cm_search-box_form-container' }, [
        [this.searchInput(function () {
                return _createElement('div', { 'className': 'form-input cm_searchInput' }, window.Convermax.config?.searchBoxPlaceholderText || _translate(`search_box_placeholder`));
            }, {
                widgetName: 'undefined',
                items: undefined
            })],
        _createElement('span', {
            'className': 'cm_search-box_clear-container',
            'key': '1102'
        }, this.inputNotEmpty ? _createElement('span', {
            'className': 'cm_search-box_clear',
            'onClick': this.clearInput,
            'key': '477'
        }, '\n    ', _translate(`search_box_clear`), '\n  ') : null),
        _createElement('div', {
            'className': 'cm_search-box_submit form-button',
            'title': 'Search',
            'aria-label': 'search button',
            'data-cm-role': 'add-query',
            'key': '1104'
        }, [_createElement('svg', {
                'className': 'cm_icon',
                'width': '16',
                'height': '16',
                'viewBox': '0 0 16 16',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '7390'
            }, _createElement('path', {
                'd': 'M12.0203 11.078L14.8757 13.9327L13.9323 14.876L11.0777 12.0207C10.0155 12.8722 8.69434 13.3353 7.33301 13.3334C4.02101 13.3334 1.33301 10.6454 1.33301 7.33337C1.33301 4.02137 4.02101 1.33337 7.33301 1.33337C10.645 1.33337 13.333 4.02137 13.333 7.33337C13.3349 8.69471 12.8718 10.0159 12.0203 11.078ZM10.683 10.5834C11.5291 9.7133 12.0016 8.54699 11.9997 7.33337C11.9997 4.75537 9.91101 2.66671 7.33301 2.66671C4.75501 2.66671 2.66634 4.75537 2.66634 7.33337C2.66634 9.91137 4.75501 12 7.33301 12C8.54663 12.002 9.71293 11.5294 10.583 10.6834L10.683 10.5834Z',
                'fill': '%23232833'
            }))])
    ]), [this.dropdown(function () {
            function repeatSections1(sections, sectionsIndex) {
                return [sections(function () {
                        function repeatItems1(items, itemsIndex) {
                            return [items(function () {
                                    function mergeProps_text(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    function mergeProps_product(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    function onError1_facetValue(e) {
                                        e.target.classList.add('cm_hide');
                                    }
                                    function mergeProps_facetValue(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    return this.template === 'text' ? _createElement('div', mergeProps_text({ 'className': 'cmTemplate_text' }, { dangerouslySetInnerHTML: { __html: typeof this.textHighlight === 'undefined' ? '' : this.textHighlight } })) : this.template === 'product' ? _createElement('div', { 'className': 'cmTemplate_product' }, _createElement('div', { 'className': 'image-block' }, _createElement('img', {
                                        'src': this.imageOrDefault(this.images_image_thumbnail1 || this.image_thumbnail || this.images_image_standard1 || this.image_standard),
                                        'alt': 'Image of ' + this.removeHTML(this.title),
                                        'onError': this.onImageError
                                    })), _createElement('div', { 'className': 'description-block' }, _createElement('div', mergeProps_product({ 'className': 'title' }, { dangerouslySetInnerHTML: { __html: typeof this.name === 'undefined' ? '' : this.name } })), _createElement('div', { 'className': 'price' }, '\n    ', this.price_varies ? `${ _translate(`price_from`) } ` : '', this.formatPrice(this.min_price || this.price), '\n  '))) : this.template === 'facetValue' ? _createElement('div', { 'className': 'cmTemplate_facetValue' }, this.imageUrl ? _createElement('div', {
                                        'className': 'image-block',
                                        'key': '35'
                                    }, _createElement('img', {
                                        'src': this.imageUrl,
                                        'alt': 'Image of ' + this.facetValue,
                                        'onError': onError1_facetValue.bind(this)
                                    })) : null, _createElement('div', { 'className': 'description-block' }, _createElement('div', mergeProps_facetValue({ 'className': 'title' }, { dangerouslySetInnerHTML: { __html: typeof this.value === 'undefined' ? '' : this.value } })), this.hitCount ? _createElement('span', {
                                        'className': 'hit-count',
                                        'key': '400'
                                    }, '(', this.hitCount, ')') : null)) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                                }, { count: undefined })];
                        }
                        return _createElement('div', { 'className': 'section' + (this.sectionTitle ? ` ${ this.sectionTitle }` : '') }, _createElement('div', { 'className': 'section-title-div' }, _createElement('div', { 'className': 'item section-title' }, _createElement('b', {}, '\n          ', this.totalHits && _translate(`search_box_products_count`, {  totalHits : this. totalHits  }), ' ', _translate(`search_box_section_${ this.sectionTitle }`) || this.sectionTitle, '\n        '), '\n        ', this.vehicleString && _translate(`search_box_dropdown_vehicle`, {  vehicleString : this. vehicleString  }), '\n      ')), _createElement.apply(this, [
                            'div',
                            { 'className': 'cmRepeater_items' },
                            _map(this.items, repeatItems1.bind(this))
                        ]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_autocomplete cm_dropdown' }, _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_sections' },
                _map(this.sections, repeatSections1.bind(this))
            ]), this.browseAllButton ? [[this.browseAllButton(function () {
                        return _createElement('a', { 'className': 'item button-item cm_browseAllButton' }, _translate(`search_box_dropdown_browse`, { 
                            totalHits: this.
                            totalHits, 
                            query
                        : this.
                            query
                         }));
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })]] : null, this.noResults ? _createElement('div', {
                'className': 'item cm_search-box_no-results',
                'key': '5323'
            }, '\n  ', _translate(`search_box_no_results`, {  query : this. query  }), '\n') : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchInput","cm:browseAllButton","cm:dropdown"]